import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { FormArray, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { Indicators } from '../../models/itens.model';

@Component({
  selector: 'app-itens-ac-indicators',
  templateUrl: './itens-ac-indicators.component.html',
  styleUrls: ['./itens-ac-indicators.component.scss','../itens-edit/itens-edit.component.scss']
})
export class ItensAcIndicatorsComponent extends BaseFormComponent<Indicators> implements OnInit {
  @Input() parentFormGroup: FormGroup = null;
  @Input() expand: boolean = false;
  @Input() check: boolean = false;
  @Input() order: boolean = false;
  @Input() currentItem: object[] = [];
  @Output() checkStatus = new EventEmitter<boolean>();
  @Output() orderItem = new EventEmitter<any>();
  constructor(
    public activatedRoute: ActivatedRoute,
  ) { 
    super(activatedRoute);
  }

  ngOnInit() {
  }

  get acIndicators(): FormArray {
    return this.parentFormGroup.get('acIndicators') as FormArray;
  }
  onCheckStatus(){
    console.log('cccccccccccccc')
    this.checkStatus.emit(true)
  }
  onOrderItem(e){
    this.orderItem.emit(e)
  }
}
